module.exports = __webpack_public_path__ + "static/img/xx_pic1.18c0520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rizhi/xx_pic1.jpg
// module id = Wr54
// module chunks = 5